import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const NotFound = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', pathname);
  }, [pathname]);

  return (
    <div className="bg-muted flex min-h-screen items-center justify-center px-4 py-12">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="text-muted-foreground mb-4 text-xl">Página não encontrada</p>
        <Link to="/" className="text-primary hover:text-primary/90 inline-flex min-h-11 items-center underline">
          Voltar ao início
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
